import { trpc } from '@/utils/trpc'
import { useState } from 'react'
import showToastNotification from './useShowToast'

export const useRemoveInvitees = () => {
  const [open, onOpenChange] = useState<boolean>(false)
  const [inviteeIdToRemove, setInviteeIdToRemove] = useState<string | null>(null)
  const utils = trpc.useUtils()

  const { mutate: removeInvite, isPending: isRemovingInvite } = trpc.removeInvite.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: `Invite Deleted`,
        description: `Invites deleted successfully!`,
      })
      utils.teamInvitees.invalidate()
    },
  })
  return { removeInvite, isRemovingInvite, open, onOpenChange, inviteeIdToRemove, setInviteeIdToRemove }
}
